import { createFileRoute } from '@tanstack/react-router'
import ComponentCard from "@/components/common/ComponentCard";
import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import BasicTableOne from "@/components/tables/BasicTableOne";
import { Metadata } from "next";
import { ROUTES } from "@/config/routes";
import React from "react";

export const metadata: Metadata = {
  title: "Next.js Basic Table | TailAdmin - Next.js Dashboard Template",
  description:
    "This is Next.js Basic Table  page for TailAdmin  Tailwind CSS Admin Dashboard Template",
  // other metadata
};

function BasicTables() {
  return (
    <div>
           <PageBreadcrumb items={[
  { label: 'Dashboard', href: ROUTES.ADMIN_DASHBOARD.path },
  { label: 'Line Chart', href: '/line-chart', active: true }
]} />
      <div className="space-y-6">
        <ComponentCard title="Basic Table 1">
          <BasicTableOne />
        </ComponentCard>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/(admin)/(others-pages)/(tables)/basic-tables/')({
  component: BasicTables,
})
